import React, { Component } from "react";
import { connect } from "react-redux";
import * as userActions from "../../../_actions/userActions";
import Wrapper from "../../../_hoc/Wrapper";
import Section from "../../UI/Section";
import Switch from "../../UI/Switch";
import getMyPrivacySetting from "../../../_selectors/userSelectors/getMyPrivacySetting";

class Privacy extends Component {
  componentDidMount() {
    const { privacy, updateHeader, updateBreadcrumb } = this.props;

    updateHeader({
      title: "Privacy Settings",
      description: "You are in control of your privacy"
    });
    updateBreadcrumb([
      { label: "Home", link: "/" },
      { label: "Profile", link: "/profile" },
      { label: "Privacy", link: "/search" }
    ]);
  }
  updatePrivacySetting = (name, value) => {
    const { updatePrivacy } = this.props;

    const updatedSetting = {
      [name]: value
    };
    updatePrivacy({ data: updatedSetting });
  };
  render() {
    const {
      images,
      phone,
      shortlist,
      like,
      expressInterest,
      rating,
      favourite,
      save,
      ignore,
      profileView,
      birthPlace,
      address,
      income,
      cache
    } = this.props.privacy;
    return (
      <Wrapper>
        <Section>
          <div className="row row-wider">
            <div class="col-md-8 col-md-offset-2">
              <div class="panel panel-default">
                <div class="panel-body" style={{ borderBottom: "0px" }}>
                  <div class="page-subtitle page-subtitle-centralized margin-bottom-0">
                    <h3>Privacy Settings</h3>
                    <p>You can change these settings at any time.</p>
                  </div>
                </div>
                <div class="panel-body list-contacts">
                  <div class="list-contacts-item ">
                    <span className="fa fa-image" />{" "}
                    <strong style={{ marginLeft: "5px" }}>Images</strong> Let
                    other members see the Images that you upload.
                    <Switch
                      value={images}
                      disabled={cache}
                      className="pull-right"
                      onChange={this.updatePrivacySetting}
                      name="images"
                    />
                  </div>
                  <div class="list-contacts-item ">
                    <span className="fa fa-phone" />{" "}
                    <strong style={{ marginLeft: "5px" }}>Phone</strong> Let
                    other members see your Mobile Number
                    <Switch
                      value={phone}
                      disabled={cache}
                      onChange={this.updatePrivacySetting}
                      className="pull-right"
                      name="phone"
                    />
                  </div>
                  <div class="list-contacts-item ">
                    <span className="fa fa-child" />
                    <strong style={{ marginLeft: "5px" }}>
                      Birth Place
                    </strong>{" "}
                    Let other members see your Birth-Place
                    <Switch
                      value={birthPlace}
                      disabled={cache}
                      onChange={this.updatePrivacySetting}
                      className="pull-right"
                      name="birthPlace"
                    />
                  </div>
                  <div class="list-contacts-item ">
                    <span className="fa fa-map-marker" />{" "}
                    <strong style={{ marginLeft: "5px" }}>Address</strong> Let
                    other members see your Address
                    <Switch
                      value={address}
                      disabled={cache}
                      onChange={this.updatePrivacySetting}
                      className="pull-right"
                      name="address"
                    />
                  </div>
                  <div class="list-contacts-item ">
                    <span className="fa fa-money" />{" "}
                    <strong style={{ marginLeft: "5px" }}>Income</strong> Let
                    other members see your Income
                    <Switch
                      value={income}
                      disabled={cache}
                      onChange={this.updatePrivacySetting}
                      className="pull-right"
                      name="income"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Section>
      </Wrapper>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  privacy: getMyPrivacySetting(state)
});
const mapDispatchToProps = dispatch => ({
  updatePrivacy: payload => dispatch(userActions.updatePrivacySetting(payload))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Privacy);



// WEBPACK FOOTER //
// ./src/_components/Profile/Privacy/index.js